import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index/Index'
import Biogram from '@/components/Biogram/Biogram'
import Biograms from '@/components/Biograms/Biograms'
import ItemPlayer from '@/components/ItemPlayer/ItemPlayer'
import NotFound from '@/components/NotFound/NotFound'
import Collections from '@/components/Collections/Collections'
import Page from '@/components/Page/Page'
import AllTags from '@/components/AllTags/AllTags'
import Listing from '@/components/Common/Listing'
import AdvancedSearch from '@/components/AdvancedSearch/AdvancedSearch'


// https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations

Vue.use(Router)

// https://stackoverflow.com/a/58439497
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

let _this = this

export default new Router({
    mode: 'history',
    scrollBehavior() {
        // set scroll to the top
        return { x: 0, y: 0, behavior: 'smooth' };
    },
    routes: [{
        path: '/',
        name: 'Index',
        component: Index,
        query: null
    },
    {
        path: '/fotografie/:page?',
        name: 'Photos',
        component: Listing,
        props: {
            page: 1,
            breadcrumbsTitle: 'Fotografie',
            apiCall: 'items?item_type=20'
        }
    },
    {
        path: '/dokumenty/:page?',
        name: 'Documents',
        component: Listing,
        props: {
            page: 1,
            breadcrumbsTitle: 'Dokumenty',
            apiCall: 'items?item_type=19'
        }
    },
    {
        path: '/nagrania/:page?',
        name: 'Recordings',
        component: Listing,
        props: {
            page: 1,
            breadcrumbsTitle: 'Nagrania',
            apiCall: 'items?item_type=28'
        }
    },
    {
        path: '/eksponaty/:page?',
        name: 'Showpieces',
        component: Listing,
        props: {
            page: 1,
            breadcrumbsTitle: 'Eksponaty',
            apiCall: 'items?item_type=24'
        }
    },
    {
        path: '/etykiety',
        name: 'AllTags',
        component: AllTags,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'tags'
        })
    },
    {
        path: '/etykieta/:tag/:page?',
        name: 'Tags',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'items?tags=' + route.params.tag
        })
    },
    {
        path: '/fotografia/:id',
        name: 'ItemPlayer',
        component: ItemPlayer,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'items/' + route.params.id
        })
    },
    {
        path: '/dokument/:id',
        name: 'ItemPlayer',
        component: ItemPlayer, 
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'items/' + route.params.id
        })
    },
    {
        path: '/eksponat/:id',
        name: 'ItemPlayer',
        component: ItemPlayer,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'items/' + route.params.id
        })
    },
    {
        path: '/nagranie/:id',
        name: 'ItemPlayer',
        component: ItemPlayer,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'items/' + route.params.id
        })
    },
    {
        path: '/biogram/:id(\\d+)',
        name: 'Biogram',
        component: Biogram,
        props: {
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'items'
        }

    },
    {

        //https://fizykoteka.ckc.uw.edu.pl/omeka/api/items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=contains&advanced[0][terms]=280&item_type=20

        path: '/biogram/:id(\\d+)/fotografie/:page?',
        name: 'BiogramPhotos',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: 'Wyniki wyszukiwania',
            apiCall: 'items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=contains&advanced[0][terms]=' + route.params.id + '&item_type=20'
        })
    },
    {
        path: '/biogram/:id(\\d+)/dokumenty/:page?',
        name: 'BiogramDocuments',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: 'Wyniki wyszukiwania',
            apiCall: 'items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=contains&advanced[0][terms]=' + route.params.id + '&item_type=19'
        })

    },
    {
        path: '/biogram/:id(\\d+)/eksponaty/:page?',
        name: 'BiogramShowpieces',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: 'Wyniki wyszukiwania',
            apiCall: 'items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=contains&advanced[0][terms]=' + route.params.id + '&item_type=24'
        })
    },
    {
        path: '/biogram/:id/powiazane/:page?',
        name: 'BiogramRelated',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: 'Wyniki wyszukiwania',
            apiCall: 'items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=is exactly&advanced[0][terms]=' + route.params.id
        })
    },
    {
        path: '/biogramy/:letter?',
        name: 'Biograms',
        component: Biograms,
        props: {
            page: 1,
            breadcrumbsTitle: 'Biogramy',
            apiCall: 'items?item_type=18'
        }
    },
    {
        // need pagination?
        path: '/kolekcje',
        name: 'Collections',
        component: Collections,
        props: {
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'collections'
        }
    },
    {
        path: '/kolekcja/:id/:page?',
        name: 'Collection',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'items?collection=' + route.params.id
        })

    },
    {
        path: '/wystawy/:page?',
        name: 'Exhibits',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'simple_exhibits'
        })
    },
    {
        //path: '/wystawa/:id/:page?',
        path: '/wystawa/:slug',
        name: 'Exhibit',
        component: Page,
        props: route => ({
            page: 1,
            breadcrumbsTitle: '',
            apiCall: 'simple_exhibits?slug=' + route.params.slug
        })

    },
    {
        path: "*",
        name: 'NotFound',
        component: NotFound
    },
    {
        path: '/szukaj/:query/:page?',
        name: 'Search',
        component: Listing,
        props: route => ({
            page: 1,
            breadcrumbsTitle: 'Wyniki wyszukiwania',
            apiCall: 'items?search=' + route.params.query,
            advanced: null
        })
    },
    {
        path: '/strona/:slug',
        name: 'Page',
        component: Page,
        props: {
            page: null,
            breadcrumbsTitle: '',
            apiCall: 'simple_pages'
        }

    },
    {
        path: '/zaawansowane',
        name: 'AdvancedSearch',
        component: AdvancedSearch,
        props: {
            page: null,
            breadcrumbsTitle: '',
            apiCall: 'simple_pages' // dac null
        }

    }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js